import { render, staticRenderFns } from "./DetailsReservierung.vue?vue&type=template&id=249734e6"
import script from "./DetailsReservierung.vue?vue&type=script&lang=ts"
export * from "./DetailsReservierung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports